import { render } from "./Form.vue?vue&type=template&id=35ca258c"
import script from "./Form.vue?vue&type=script&setup=true&lang=js"
export * from "./Form.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Common/Form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35ca258c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35ca258c', __exports__)) {
    api.reload('35ca258c', __exports__)
  }
  
  module.hot.accept("./Form.vue?vue&type=template&id=35ca258c", () => {
    api.rerender('35ca258c', render)
  })

}


export default __exports__